var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0089 27.5169C21.9166 27.5169 27.5164 21.9171 27.5164 15.0094C27.5164 8.10173 21.9166 2.50195 15.0089 2.50195C8.10125 2.50195 2.50146 8.10173 2.50146 15.0094C2.50146 21.9171 8.10125 27.5169 15.0089 27.5169Z",
    stroke: "#E7B92A",
    strokeWidth: 2.50149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0093 7.50488V15.0094L20.0123 17.5109",
    stroke: "#E7B92A",
    strokeWidth: 2.50149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.778465843f3dde812869dbebc70cd689.svg";
export { ForwardRef as ReactComponent };